import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

if (process.env.NODE_ENV === 'development') {
  void import('./reticle-dev');
}

const root = ReactDOM.createRoot(document.getElementById("root"));

// Suppress benign ResizeObserver error to prevent runtime crash overlay
// This is often triggered by browser extensions or benign layout shifts
const resizeObserverLoopErr = /ResizeObserver loop completed with undelivered notifications/;

window.addEventListener("error", (e) => {
  if (resizeObserverLoopErr.test(e.message)) {
    e.stopImmediatePropagation();
  }
});

const originalOnError = window.onerror;
window.onerror = function (msg, url, lineNo, columnNo, error) {
  if (resizeObserverLoopErr.test(msg)) {
    return true; // suppresses error
  }
  if (originalOnError) {
    return originalOnError(msg, url, lineNo, columnNo, error);
  }
  return false;
};

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
